import { RepositoryFactory } from '../../repositories/RepositoryFactory'
const libraryRepository = RepositoryFactory.get('library')

const defaultState = () => ({
  items: [],
  length: 0,
  paged: 0,
  tags: [],
})

const state = defaultState()

const getters = {}

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  setTags(state, tags) {
    console.log("tags:",tags)
    state.tags = tags
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ state, commit }, { tagIds, sortBy, perPage }) {
    try {
      const { succeed, reportArticles, tags } = await libraryRepository.getTag(
        tagIds,
        sortBy,
        state.paged * perPage,
        perPage
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', reportArticles)
        commit('setTags', tags)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
